module.exports = __webpack_public_path__ + "assets/icons/chat-icon-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/chat/chat-icon-black.png
// module id = ./src/styles/icons/chat/chat-icon-black.png
// module chunks = 0